/* global Provider */
import React, { Component } from 'react';
import Questions from '../entities/questions.json';
import DOL from '../img/img-dol.png';
import Select from 'react-select';


export default class MultiQuestion extends Component {
    constructor(props){
        super(props);

        this.state = {
            selected: null,
            altSelected: null,
            altNotes: null,
            altOther: null,
            twoDimensional: Questions[this.props.id]['twoDimensional']
        }
    }

    reset(){
        this.setState({ selected: null });
    }

    render() {
        let data = Questions[this.props.id];
        if (!data)return null;

        let isAltEnabled = this.state.selected && this.state.selected.id === '1';

        return (
            <div className="survey-question">  
                {data.tip?
                    <div className="tip">
                        <p><img src={DOL} alt="DOL Tip" /></p>
                        <p><b>DOL Tip for ERISA Plan Fiduciaries:</b> {data.tip}</p>
                    </div>              
                : null }
                <span className="clearfix">
                    {this.props.id}. {data.text}
                    { data.help ? 
                        <i className="fas fa-question-circle" onClick={() => {
                            Provider.showModal('Question ' + this.props.id + ' Help', data.help, null, null, null, null, null, data.helpImage);
                        }}></i>
                    : null }
                </span>
                <div className="row">
                    {data.options.map((option, index) => {
                        return(
                            <div key={"option-" + index} className={"col-sm " + (this.state.selected === option ? 'active' : '')} data-hint={option.hint} onClick={(event) => {
                                this.setState({ selected: option }, () => {
                                    Provider.setResponse(this.props.id, this.state);
                                });                                
                                if (this.props.onAfterSelection)this.props.onAfterSelection(event, option, index);                                
                            }}                                
                            >
                                <span dangerouslySetInnerHTML={{__html: option.text }} />
                            </div>
                        );
                    })}
                </div>
                {data.altText ? 
                    <div>
                        <div className="mt-3">
                            <span className="">{data.altText}</span>
                            <div className="row"> 
                                { data.twoDimensional ? <div className="row" style={{marginLeft: 0, marginRight: 0, marginTop: "10px"}}>
                                    <div className="col-sm field">
                                        <span className="">{data.col1Name}</span>
                                        {data.col1Options.map((option, index) => {
                                            return(
                                                <div key={"option-" + index + "-1"} className={"col-sm " + (this.state.selected === option ? 'active' : '')} data-hint={option.hint}                                
                                                >
                                                    <input type="checkbox" style={{marginRight: "10px"}} onChange={(event) => {
                                                        if (event.target.checked) {
                                                            this.setState({ selectedLeftColumn: option.text }, () => {
                                                                Provider.setResponse(this.props.id, this.state);
                                                            });                                
                                                            if (this.props.onAfterSelection)this.props.onAfterSelection(event, option, index); 
                                                        } else {
                                                            this.setState({ selectedLeftColumn: null }, () => {
                                                                Provider.setResponse(this.props.id, this.state);
                                                            });                                
                                                            if (this.props.onAfterSelection)this.props.onAfterSelection(event, option, index);
                                                        }                              
                                                    }} /> 
                                                    <span dangerouslySetInnerHTML={{__html: option.text }} />
                                                    { (option.text === 'v. Other' && this.state.selectedLeftColumn === 'v. Other') ? <textarea className="form-control" placeholder="If Other, please describe." onChange={(event) => {
                                                        this.setState({ leftColumnNotes: event.target.value }, () => {
                                                            Provider.setResponse(this.props.id, this.state);
                                                        });
                                                    }} /> : null }
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <div className="col-sm field">
                                        <span className="">{data.col2Name}</span>
                                        {data.col2Options.map((option, index) => {
                                            return(
                                                <div key={"option-" + index + "-2"} className={"col-sm " + (this.state.selected === option ? 'active' : '')} data-hint={option.hint}                                
                                                >
                                                    <input type="checkbox" style={{marginRight: "10px"}} onChange={(event) => {
                                                        if (event.target.checked) {
                                                            this.setState({ selectedRightColumn: option.text }, () => {
                                                                Provider.setResponse(this.props.id, this.state);
                                                            });                                
                                                            if (this.props.onAfterSelection)this.props.onAfterSelection(event, option, index);
                                                        } else {
                                                            this.setState({ selectedRightColumn: null }, () => {
                                                                Provider.setResponse(this.props.id, this.state);
                                                            });                                
                                                            if (this.props.onAfterSelection)this.props.onAfterSelection(event, option, index);
                                                        }                                
                                                    }} /> 
                                                    <span dangerouslySetInnerHTML={{__html: option.text }} />
                                                    { (option.text === 'v. Other' && this.state.selectedRightColumn === 'v. Other') ? <textarea className="form-control" placeholder="If Other, please describe." onChange={(event) => {
                                                        this.setState({ rightColumnNotes: event.target.value }, () => {
                                                            Provider.setResponse(this.props.id, this.state);
                                                        });
                                                    }} /> : null }
                                                </div>
                                            );
                                        })}
                                    </div>
                                    </div> : <div className="mt-2 col-sm field">                       
                                    <Select
                                        className=""
                                        classNamePrefix=""
                                        isSearchable={true}
                                        isClearable={true}
                                        isDisabled={!isAltEnabled}
                                        isMulti={false}
                                        options={data.altOptions.map((item) => {
                                            return { value: item.text, label: item.text, option: item  };
                                        })}
                                        placeholder={'Select'}
                                        onChange={(selected) => {
                                            //console.log("selected option:",selected);
                                            this.setState({ altSelected: (selected ? selected.option : null), altOther: (selected ? this.state.altOther : null) }, () => {
                                                Provider.setResponse(this.props.id, this.state);
                                            }); 
                                        }}  
                                    />
                                </div>}
                            </div>
                            { this.state.altSelected && this.state.altSelected.text === 'Other' ?
                                <div className="mt-2 row">
                                    <div className="col-sm field">
                                        <input type="text" className="form-control" placeholder="Please describe..." onChange={(event) => {
                                            this.setState({ altOther: event.target.value }, () => {
                                                Provider.setResponse(this.props.id, this.state);
                                            });                                    
                                        }}/>
                                    </div>
                                </div>
                            : null }
                            {data.notes ? 
                                   <div className="mt-3"><span className="">Notes:</span>
                                   <div className="row"> 
                                        <div className="mt-2 col-sm field">
                                              
                                                    <textarea className="form-control" placeholder="Notes" onChange={(event) => {
                                                    this.setState({ altNotes: event.target.value }, () => {
                                                        Provider.setResponse(this.props.id, this.state);
                                                    });
                                                }}/>


                                            </div> 
                                   </div>
                                   
                                   
                                   </div>
                            : null }
                        </div>
                    </div>
                : <div>
                    {data.notes ? 
                        <div className="mt-3"><span className="">Notes:</span>
                           <div className="row"> 
                                <div className="mt-2 col-sm field">
                                      
                                            <textarea className="form-control" placeholder="Notes" onChange={(event) => {
                                            this.setState({ altNotes: event.target.value }, () => {
                                                Provider.setResponse(this.props.id, this.state);
                                            });
                                        }}/>


                                    </div> 
                           </div>
                           
                           
                           </div>
                    : null }
                </div> }
            </div>
        );
    }
}
